import styled from 'styled-components/macro';
import { TicketTextRegular } from '../../common/fontElements';
import { DropdownSelect } from '../../common/formElements';
import { mediumHeightScreens } from '../../common/fontElements';
import { panelHeaderHeight } from '../../common/layout';
import * as colors from 'components/common/colorConstants';

export const SearchOrdersPageWrapper = styled(TicketTextRegular)`
  color: #7f7f7f;
  white-space: normal;
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: 1.8rem;
  height: 100%;
  text-align: center;
  display: grid;
  grid-template-rows: min-content auto;
`;

export const SearchOrderContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SearchHeader = styled.div`
  display: flex;
  min-height: auto;
  ${panelHeaderHeight};
  align-items: center;
  padding: 0 20px;
  flex-shrink: 0;
  height: 45px;
`;

export const HeaderSmbDescription = styled.div`
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.isBackButton ? 'pointer' : 'default')};
`;

export const SMBName = styled(TicketTextRegular)`
  display: inline-block;
  letter-spacing: 0;
  font-size: 12px;
  color: ${colors.darkGray1};

  .tooltip-icon {
    margin-left: 6px;
  }
`;

export const SearchAndResults = styled.div`
  overflow-y: scroll;
  height: 100%;
`;

export const SearchAllResults = styled.div`
  overflow-y: scroll;
  height: 100%;
  padding: 20px 32px;
`;

export const SearchErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const ErrorMessage = styled.h1`
  text-align: center;
  color: #d1d1d1;
  font-size: 2rem;
  font-family: 'Lato-Light', sans-serif;
  padding-top: 50px;
  letter-spacing: 1.2px;
`;

ErrorMessage.displayName = 'ErrorMessage';

export const NoStoreIntegrationMessage = styled(ErrorMessage)`
  font-size: 30px;
  padding-top: 0;
  padding-bottom: 10%;
`;

export const ButtonLink = styled.a`
  line-height: 1.8rem;

  &.disabled-link {
    cursor: default;
  }
`;

export const KnowledgeBaseButtons = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

KnowledgeBaseButtons.displayName = 'KnowledgeBaseButtons';

export const SearchTitleBox = styled.div``;

export const BlueSection = styled.div`
  height: min-content;
  background-color: ${colors.baseBackground};
  border-bottom: ${(props) => props.border && `1px solid ${colors.lightGray11}`};
  padding: 0px 28px 15px;
  @media (max-height: ${mediumHeightScreens}) {
    padding: 5px 28px;
  }
`;

export const ResultsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
`;

export const SearchOrdersBox = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;

  & > * {
    padding: 5px;
    flex: 1 0;
  }
`;
SearchOrdersBox.displayName = 'SearchOrdersBox';

export const SearchAllBox = styled.div`
  padding: 0 4rem 1rem;
  max-width: 600px;
  margin: auto;
`;
SearchAllBox.displayName = 'SearchAllBox';

export const ResultsBox = styled.div`
  text-align: left;
  height: 50px;
  /* border: 1px solid green; */
`;
ResultsBox.displayName = 'ResultsBox';

export const ResultsCancelSubscriptionBox = styled.div`
  padding: 0px 25px 25px 25px;
  text-align: left;

  & table {
    table-layout: fixed;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 1500px) {
    padding: 15px 25px;
  }
`;
ResultsCancelSubscriptionBox.displayName = 'ResultsCancelSubscriptionBox';

export const ResultsTable = styled.div`
  margin-bottom: 0 !important;
`;
ResultsTable.displayName = 'ResultsTable';

export const ResultsHeader = styled.thead`
  margin-bottom: 0 !important;
`;
ResultsHeader.displayName = 'ResultsHeader';

export const SearchPageSelect = styled(DropdownSelect)`
  border-radius: 3px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  height: auto !important;
  overflow-y: auto;
`;

export const SearchAllResult = styled.div`
  color: ${colors.black4};
  font-family: 'Roboto', sans-serif;
  background: ${colors.lightGray7};
  border-radius: 3px;
  padding: 15px;
  cursor: pointer;
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  transition: 0.3s;

  & em {
    background-color: ${colors.green3};
    color: ${colors.whiteText};
    font-style: normal;
  }

  &:hover {
    background: ${colors.lightGray31};
  }
`;

export const SearchAllResultHeading = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
`;

export const SearchAllDeleteButton = styled.button`
  font-weight: 500;
  color: ${colors.darkGray1};
  background: none;
  padding: 0px;
  margin: 0px;
  border: none;
  height: 14px;
`;

export const SearchAllDate = styled(SearchAllResultHeading)`
  color: ${colors.darkGray1};
`;

export const SearchAllResultTextContainer = styled.div`
  width: calc(100% - 70px);
  display: inline-block;
`;

export const SearchAllButtonContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;
`;
